'use strict';

function isGenerator(type) {
    return typeof type === "function" && "applyToOptions" in type;
}

exports.isGenerator = isGenerator;
//# sourceMappingURL=is-generator.cjs.map
